<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_xi"></a>THE GOOD PSYCHOLOGIST</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?3edf70d3